// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"39":"468eb7b6","523":"2fadc02b","636":"6f511fd9","980":"831de81e"}[chunkId] + ".css";
};